<script type="text/javascript">
import swal from 'sweetalert';

export default {
  name: 'AskDelegateAboutSupplier',
  props: ['delegate', 'meeting'],
  created() {
    this.showAlert()
  },
  methods: {
    showAlert() {
      let self = this
      swal( `Would you consider doing business with \n ${this.meeting.title}?`, {
        className: "ask-delegate-about-supplier",
        buttons: {
          yes: {
            text: "YES",
            value: "yes",
          },
          no: {
            text: "NO",
            value: "no",
          },
          maybe: {
            text: "MAYBE",
            value: "maybe",
          }
        },
      }).then((value) => {
        if (value) {
          this.meeting.answered_about_doing_business_with_supplier = true
          this.$http.secured.post(`/attendee_api/v1/does_delegate_want_to_do_business_with_supplier/${this.meeting.supplier_id}`, {answer: value})

          swal("Thank you!", "Thank you for your feedback!", "success", {
            buttons: false,
            timer: 1500
          });
        }
        setTimeout(() => {
          self.$destroy()
        }, 1500)
      });
    },
  }
}
</script>

